module.exports = __webpack_public_path__ + "img/sidenav-item-pending-approval.2df390fa.svg";